import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import WorkCalendar from "../../../containers/modules/master/work-calendar";

export default function WorkCalendarRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="setup-warehouse"
      index
      element={
        <AccessControl
          name={"Work Calendar List"}
          auth={authUser}
          component={() => <WorkCalendar authUser={authUser} />}
        />
      }
    />
  );
}
